import creditNote from "@/components/creditnote/CreditNoteComponent.vue";
import AdminOrdersSubMenusLinks from "@/components/menu/sub-menus/orders/AdminOrdersSubMenusLinks.vue";
export default {
  name: "adminCreditNote",
  components: {
    creditNote: creditNote,
    AdminOrdersSubMenusLinks: AdminOrdersSubMenusLinks
  },
  props: {
    loggedUserData: Object
  }
};